import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { OFFER_HASH } from "../../data/links";
type CtaButtonProps = {
  label: string;
  sub?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
};
export function CtaButton({
  label,
  sub,
  href = OFFER_HASH,
  onClick,
  className = ""
}: CtaButtonProps) {
  return <a href={href} onClick={onClick} className={`group inline-flex w-full max-w-md flex-col items-center justify-center rounded-lg bg-gold px-6 py-3.5 text-center text-navy shadow-[0_4px_0_0_#9C7C17] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:translate-y-[1px] hover:bg-gold-bright hover:shadow-[0_3px_0_0_#9C7C17] active:translate-y-[4px] active:shadow-none focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 ${className}`} data-id="element-69" data-mp="2ros2q27h0c6k">
      <span className="flex items-center gap-2 font-display text-base font-black uppercase leading-tight tracking-tight md:text-lg" data-id="element-70" data-mp="1bas6p2bqx6ol">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-71" data-mp="2y4aj58xg9ll2" />
      </span>
      {sub && <span className="mt-0.5 text-xs font-semibold text-navy/85 md:text-sm" data-id="element-72" data-mp="2t70lx73tk5mo">{sub}</span>}
    </a>;
}